import { CATEGORY, TRACK_TYPE } from '@lib/analyticsEvents';
import { stores } from '@stores/.';

interface IAnalyticsStore {
  track: (
    message: string,
    action: TRACK_TYPE,
    category: CATEGORY,
    props?: Record<string, unknown>,
    cb?: () => void,
  ) => void;
}

const enhanceProps = (props: Record<string, unknown>) => {
  const { userStore } = stores;
  const { id, email, selectedWorkspaceId, loggedIn, name } = userStore;
  if (loggedIn) {
    return {
      userId: id,
      email,
      name,
      workspaceID: selectedWorkspaceId,
      ...props,
    };
  }
  return props;
};

class Analytics implements IAnalyticsStore {
  public track = (
    message: string,
    action: TRACK_TYPE,
    category: CATEGORY,
    p: Record<string, unknown> = {},
    cb: () => void = () => null,
  ): void => {
    const props = enhanceProps(p);
    if (cb) {
      window?.rudderanalytics?.track(message, { action, category, ...props }, cb);
      return;
    }
    window?.rudderanalytics?.track(message, { action, category, ...props });
  };

  public page = (
    category: CATEGORY,
    name: string,
    properties: Record<string, unknown> = {},
    cb: () => void = () => null,
  ) => {
    const options = enhanceProps({});
    if (cb) {
      window?.rudderanalytics?.page(category, name, properties, options, cb);
      return;
    }
    window?.rudderanalytics?.page(category, name, properties, options);
  };
}

export const analytics = new Analytics();
